import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

export interface Label {
  id: number;
  name: string;
  environmentId: number;
  environment: {
    id: number;
    name: string;
    host: string;
  };
}

export interface LabelsByEnvironmentResponse {
  labelsByEnvironment: Label[];
}

const GET_LABELS_BY_ENVIRONMENT = gql`
  query GetLabelsByEnvironment($environmentId: Int!) {
    labelsByEnvironment(environmentId: $environmentId) {
      id
      name
      environmentId
      environment {
        id
        name
        host
      }
    }
  }
`;

export const getAllLabelsByEnvironment = async (
  environmentId: number,
): Promise<Label[]> => {
  try {
    const { data } = await apolloClient.query<LabelsByEnvironmentResponse>({
      query: GET_LABELS_BY_ENVIRONMENT,
      variables: { environmentId },
    });

    return data.labelsByEnvironment || [];
  } catch (error) {
    console.error('Error fetching labels by environment:', error);
    throw error;
  }
};
